/** @format */

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ErrorMarginServices from "../../Services/ErrorMarginServices";
import SimpleReactValidator from "simple-react-validator";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

export const ErrorMargin = () => {
  const [, setForceUpdate] = useState("");
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const history = useHistory();
  const [loader, setLoader] = useState();
  const [marginItem, setMarginItem] = useState([]);

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getMarginItem();
  }, []);

  const getMarginItem = () => {
    setLoader(true);
    ErrorMarginServices.getErrorMargindata().then((result) => {
      if (result.status === true) {
        setMarginItem(result.data);
        setLoader(false);
      } else {
        toast.error(result.message);
        setLoader(false);
      }
    });
  };

  const eventHandler = (e, id) => {
    const { value, name } = e.target;
    let arry = [...marginItem];
    arry.map((item, key) => {
      for (const indx in item) {
        if (Object.hasOwnProperty.call(item, indx)) {
          if (key === id) {
            if (name === indx) {
              item[indx] = value;
            }
          }
        }
      }
    });

    setMarginItem(arry);
  };

  const updateHandler = (key, marginData) => {
    var find_value = [];
    if (key === marginData.margin_type) {
      find_value = ["volume_percentage", "weight_percentage"];
      var validate =
        Validator.current.fieldValid(key + "Chargeable Weight") &&
        Validator.current.fieldValid(key + "Chargeable Volume");
    }

    var postData = { id: marginData["_id"] };
    find_value.forEach(function (e) {
      postData[e] = marginData[e];
    });

    if (validate) {
      setLoader(true);
      ErrorMarginServices.updateErrorMargindata(postData).then((result) => {
        if (result.status === true) {
          getMarginItem();
          setLoader(false);
          toast.success(result.message);
        } else {
          toast.error(result.message);
          setLoader(false);
        }
      });
    } else {
      Validator.current.showMessages();
    }
  };

  return (
    <>
      <div class="d-flex justify-content-end mb-3">
      {
        (CheckAccess(217,"add") ||  user_type === "SUPERADMIN" )&& 
        <button
          class="btn btn-primary w-sm waves-effect waves-light"
          onClick={() => history.push("add-error-margin")}
        >
          Add Error Margin
        </button>
      }
      </div>
      <div className="row">
        {marginItem &&
          marginItem.length >= 0 &&
          marginItem.map((list, key) => {
            return (
              <div className="col-lg-6">
                <div className="card">
                  <div class="d-flex mb-3 align-items-center card-header">
                    <h5 class="mb-0 me-auto">
                      Error Margin &nbsp;{" "}
                      <small className="text-muted">({list.margin_type=="tnt"?'Land':list.margin_type})</small>
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-6">
                        <label>Margin Type</label>
                      </div>
                      <div className="col-6">
                        <input
                          type="text"
                          className="form-control"
                          value={list.margin_type=="tnt"?'Land':list.margin_type}
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">
                        <label>Error Margin On Weight(%)</label>
                      </div>
                      <div className="col-6">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Chargeable Weight"
                          name="weight_percentage"
                          value={list.weight_percentage}
                          onChange={(e) => eventHandler(e, key)}
                        />
                        {Validator.current.message(
                          list.margin_type + "Chargeable Weight",
                          list.weight_percentage,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-6">
                        <label>Error Margin On Volume(%)</label>
                      </div>
                      <div className="col-6">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Chargeable Volume"
                          value={list.volume_percentage}
                          name="volume_percentage"
                          onChange={(e) => eventHandler(e, key)}
                        />
                        {Validator.current.message(
                          list.margin_type + "Chargeable Volume",
                          list.volume_percentage,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    {
                       (CheckAccess(217,"edit") || user_type === "SUPERADMIN") && 
                    <button
                      class="btn btn-primary ms-auto d-block mt-3"
                      onClick={() => updateHandler(list.margin_type, list)}
                    >
                      Update
                    </button>
                    }
                  </div>
                </div>
              </div>
            );
          })}

        <Loader isShow={loader} />
      </div>
    </>
  );
};
